export default __webpack_public_path__ + "static/media/mountains.f1cc96f8.jpg";